import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import _ = require('lodash');
import moment = require('moment');
import { Subject } from 'rxjs';
import { ReviewStatus } from 'src/app/enums/roadmapReviewStatus';
import { RiskEvaluationService } from '../../../services/risk-evaluation.service';
import { RiskEvalutionExecutionService } from '../../../services/risk-evalution-execution.service';

@Component({
  selector: 'app-risk-questionnaire-review',
  templateUrl: './risk-questionnaire-review.component.html',
  styleUrls: ['./risk-questionnaire-review.component.css']
})
export class RiskQuestionnaireReviewComponent implements OnInit {
 reviewForm: FormGroup;
  toggle = true;
  evaluationReviewTypeDatas = [];
  evaluationName: any;
  scoreRange: any;
  endDate: any;
  evaluationType: any;
  evaluationReviewCriteria = [];
  questionListAgainstCriteria = [];
  evaluationFormId: any;
  userInfo: any;
  disableReviewButton: boolean = false;
  evaluationCriteriaDetails = [];
  evaluationCriterialist = [];
  criteria: any;
  islastCriteria: Boolean = false;
  // collection = [];
  p: number = 1;
  formId: any;
  scoreParticular: any[];
  shouldShow: boolean = true;
  showSpinner: boolean = false;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  todayDate: Date = new Date();
  isAnonymous: boolean = false;
  reviewerId: any;
  disableSavebutton: boolean = false;
  showAcceptButton: boolean = false;
  qId: string | null = null;;

  constructor(
    private riskEvaluationExecutionService: RiskEvalutionExecutionService,
    private riskEvaluationService: RiskEvaluationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    // for (let i = 1; i <= 100; i++) {
    //   this.collection.push(`item ${i}`);
    // }
  }

  ngOnInit() {
    $('body').removeClass('dashboard-page');

    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      language: {
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
    };

    this.reviewForm = new FormGroup({});

    this.userInfo = JSON.parse(localStorage.getItem('user'));
    this.getDetails();
    this.route.params.subscribe((params) => {
      this.formId = params.formDetails;
      this.reviewerId = params.ReviewerId;
    });

    if (this.userInfo._id == this.reviewerId) {
      this.showAcceptButton = true;
    } else {
      this.showAcceptButton = false;
    }

    this.getFormDetailsByFomId(this.formId);
  }

  closeForm(id) {
    $('#' + id).modal('toggle');
  }

  getDetails() {
    var self = this;
    $('#evaluationReviewTable').DataTable().destroy();
    this.riskEvaluationExecutionService
      .getEvaluationReviewFormDetails(this.userInfo._id)
      .then((response) => {
        if (response.status == 0) {
           } else {
           }
      });
  }

  getFormDetailsByFomId(formId) {
    var self = this;
    
    this.riskEvaluationService
      .getFormDetailsByFormId(formId)
      .then((response) => {
        if (response.status == 0) {
          this.evaluationReviewTypeDatas = response.EvaluationQuestionnaire;
          this.formId = response.EvaluationQuestionnaire[0]._id;
          this.evaluationCriteriaDetails =
            response.EvaluationQuestionnaire[0].EvaluationCriterias;
          this.toGetLastIndexOfArray(this.evaluationCriteriaDetails);
          _.forEach(this.evaluationCriteriaDetails, function (criteria) {
            if (_.size(criteria)) {
              _.forEach(
                criteria.EvaluationQuestion,
                function (questionDetails) {
                  if (_.size(questionDetails)) {
                    self.reviewForm.addControl(
                      questionDetails.EvaluationQuestionId._id,
                      new FormControl('', [])
                    );
                  }
                }
              );
            }
          });

          var reviewerCommentsDataById = this.reviewerId;

          var ReviewersData = response.EvaluationQuestionnaire[0].Reviewers; // whole reviewer from API FORM
          this.scoreParticular =
            response.EvaluationQuestionnaire[0].ScoreParticulars;
          //filter our reviewersdata by above ID
          if (_.size(this.scoreParticular)) {
            _.forEach(this.scoreParticular, function (scoreParticularDetails) {
              if (_.size(scoreParticularDetails)) {
              }
            });
          }

          var reviewerDataToShow = _.filter(ReviewersData, function (reviewer) {
            return reviewer.ReviewerId._id == reviewerCommentsDataById;
          });

          if (_.size(reviewerDataToShow)) {
            if (_.size(reviewerDataToShow[0].Comments)) {
              _.forEach(
                reviewerDataToShow[0].Comments,
                function (reviewComment) {
                  self.reviewForm.controls[reviewComment.EvaluationQuestionId]
                    ? self.reviewForm.controls[
                        reviewComment.EvaluationQuestionId
                      ].setValue(reviewComment.commentText)
                    : console.log('');
                }
              );
            }
          }

          var firstCriteriaId =
            this.evaluationCriteriaDetails[0].EvaluationCriteriaID._id;
          this.criteria = _.filter(
            this.evaluationCriteriaDetails,
            function (element) {
              return (
                _.get(_.get(element, 'EvaluationCriteriaID'), '_id') ==
                firstCriteriaId
              );
            }
          );
          
          $(document).ready(function () {
            document
              .getElementById('0')
              .parentElement.classList.add('categoryHighlight');
          });
        } else {
          this.evaluationReviewTypeDatas = response.EvaluationQuestionnaire;
        }
      });
  }

  toGetLastIndexOfArray(object) {
    var i = 1;
    var length = _.size(this.evaluationCriteriaDetails);
    
    if (length == 1) {
      this.islastCriteria = true;
    }
  }

  showFormDetails(evaluationGetData) {
    this.evaluationFormId = evaluationGetData._id;
    this.disableReviewButton = this.checkReviewStatus(evaluationGetData);
    var self = this;
    $('#viewFormDetailsDialogBox').modal('toggle');
    self.questionListAgainstCriteria = [];
    this.evaluationType = evaluationGetData.EvaluationTypeID.EvaluationType;
    this.evaluationName = evaluationGetData.EvaluationFormTitle;
    this.scoreRange = evaluationGetData.ScoreRange;
    var date = new Date(evaluationGetData.EndDate);
    this.endDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
    this.evaluationReviewCriteria = evaluationGetData.EvaluationCriterias;
    this.isAnonymous = evaluationGetData.IsAnonymous.toString();
    evaluationGetData.EvaluationCriterias.forEach(function (element) {
      self.questionListAgainstCriteria.push({
        EvaluationCriteria: element.EvaluationCriteriaID,
        EvaluationQuestion: element.EvaluationQuestion,
      });
    });
  }

  reviewApproved() {
    var userId = this.userInfo._id;
    var reviewObject = {
      userId: userId,
      EvaluationFormId: this.evaluationFormId,
    };
    this.riskEvaluationService
      .reviewApproved(reviewObject)
      .then((response) => {
        if (response.status == 0) {
          $('#viewFormDetailsDialogBox').modal('toggle');
          $('#alertTitle').text('Success!');
          $('#alertTitle').css('color', 'black');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          $('#selectedCriteriatable').DataTable().destroy();
          this.messagePopUpTimeoutToogle();
          this.getDetails();
        } else {
          $('#viewFormDetailsDialogBox').modal('toggle');
          $('#alertTitle').css('color', '#f00');
          $('#alertTitle').text('Failure!');
          $('#alertMessage').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getDetails();
        }
      });
  }

  checkReviewStatus(formDetails) {
    var self = this;
    if (_.size(formDetails.Reviewers)) {
      var index = _.findIndex(formDetails.Reviewers, function (reviewer) {
        return _.get(reviewer, 'ReviewerId') == self.userInfo._id;
      });

      if (index >= 0) {
        if (
          formDetails.Reviewers[index].ReviewerStatus == ReviewStatus.Approve
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 2000);
  }

  questionListAgainstCriteriaList(evalCriteriaId, isLast, count, event) {
    if (_.size(this.evaluationCriteriaDetails)) {
      var listSize = _.size(this.evaluationCriteriaDetails);
      var i = 0;
      for (i; i < listSize; i++) {
        if (i == count) {
          document
            .getElementById(i.toString())
            .parentElement.classList.add('categoryHighlight');
        } else {
          if (
            document
              .getElementById(i.toString())
              .parentElement.classList.contains('categoryHighlight')
          ) {
            document
              .getElementById(i.toString())
              .parentElement.classList.remove('categoryHighlight');
          }
        }
      }
    }

    this.toggle = !this.toggle;
    this.criteria = _.filter(
      this.evaluationCriteriaDetails,
      function (element) {
        return (
          _.get(_.get(element, 'EvaluationCriteriaID'), '_id') == evalCriteriaId
        );
      }
    );

    if (isLast) {
      this.islastCriteria = isLast;
    } else {
      this.islastCriteria = isLast;
    }
   
  }

  checkCategoryHighlight() {
  }

  questionWithComments(status) {
    this.disableSavebutton = true;
    this.showSpinner = true;
    var userId = this.userInfo._id;
    var reviewStatus;
    if (ReviewStatus.Approve == status) {
      reviewStatus = ReviewStatus.Approve;
    }

    if (ReviewStatus.Reject == status) {
      reviewStatus = ReviewStatus.Reject;
    }

    var reviewObject = {
      userId: userId,
      EvaluationFormId: this.formId,
      ReviewStatus: reviewStatus,
    };

    this.riskEvaluationService
      .reviewApproved(reviewObject)
      .then((response) => {
        this.disableSavebutton = false;
        if (response.status == 0) {
          this.showSpinner = false;
          $('#viewFormDetailsDialogBox').modal('toggle');
          $('#alertTitle').text('Success!');
          $('#alertTitle').css('color', 'black');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          $('#selectedCriteriatable').DataTable().destroy();
          this.messagePopUpTimeoutToogle();
          this.router.navigate([
            'structure',
            { outlets: { 'structure-outlet': ['riskEvaluationReview'] } },
          ]);
          this.getDetails();
        } else {
          this.showSpinner = false;
          $('#viewFormDetailsDialogBox').modal('toggle');
          $('#alertTitle').css('color', '#f00');
          $('#alertTitle').text('Failure!');
          $('#alertMessage').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getDetails();
        }
      });
  }

  commentChangeEvent(event, questionId) {
    if (event.target.value.trim() == '') {
      this.reviewForm.controls.comment.setValue(event.target.value.trim());
      this.reviewForm.controls.comment.updateValueAndValidity();
    }
    var comment = event.target.value;
   
    var questionObjt = {
      questionId: questionId,
      commentText: comment,
      formId: this.formId,
      reviewerId: this.userInfo._id,
    };
   
    this.riskEvaluationService
      .updateReviewerComments(questionObjt)
      .then((response) => {
        if (response.status == 0) {
        } else {
        }
      });
  }

    toggledept(questionID: string) {
    this.qId = this.qId === questionID ? null : questionID;
  }
}

